var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title":_vm.__('General')}},[_c('router-link',{attrs:{"to":{ name: 'settings.site' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ navigate }){return [_c('General')]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }